var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 140 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.755 44.5148L117.494 37.2859C115.293 34.7915 112.073 33.2182 108.486 33.2182C101.854 33.2182 96.4774 38.5945 96.4774 45.2266C96.4774 49.8231 99.0599 53.8164 102.853 55.8347L135.158 75.3388C134.432 81.5279 132.844 87.6001 130.431 93.3794C127.009 101.576 121.992 109.022 115.669 115.293C109.345 121.564 101.839 126.537 93.5782 129.927C85.3175 133.318 76.4646 135.059 67.5255 135.052C54.4322 135.052 41.6167 131.304 30.6158 124.257C19.6148 117.21 10.8952 107.163 5.50267 95.3212L10.3572 90.5031L17.6472 97.7605C19.8477 100.258 23.0701 101.834 26.6606 101.834C33.2925 101.834 38.6688 96.4578 38.6688 89.8258C38.6688 85.2333 36.0908 81.2429 32.3031 79.2229L0 59.7201C1.76253 44.6852 8.5799 30.5877 19.4713 19.7779C32.2304 7.11434 49.5355 2.01112e-05 67.5797 2.01112e-05C80.6716 -0.0100044 93.4887 3.72772 104.494 10.7651C115.5 17.8025 124.227 27.8409 129.63 39.6769L124.755 44.5148Z",
    fill: "#E42734"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo_small.db86edaf218f39da55729b65337f3d81.svg";
export { ForwardRef as ReactComponent };